import { ToastContainer } from "react-toastify";
import AppRouter from "./components/routes/AppRouter";
import PageLoader from "./components/PageLoader";
import { LocalizationProvider } from "./components/context/LocalizationContext";
import { ThemeProvider } from "./components/context/ThemeContext";
import { SkeletonTheme } from "react-loading-skeleton";
function App() {
  return (
    <SkeletonTheme
      baseColor={"var(--skeleton-base)"}
      highlightColor={"var(--skeleton-highlight)"}
    >
      <ThemeProvider>
        <LocalizationProvider>
          <PageLoader />
          <AppRouter />
          <ToastContainer />
        </LocalizationProvider>
      </ThemeProvider>
    </SkeletonTheme>
  );
}

export default App;
